import {
  createSearchAndFilterDisplayOptions,
  getDefaultRequestFields,
  mapLoyaltyEducation,
  mapMessages,
  mapOmnitureData,
  mapPropertySearchResults,
  mapSearchedDestination,
  mapSortAndFilter,
  SearchMigrationAdapter
} from 'stores/adapters';
import { mapMap } from 'src/common/stores/adapters/bex-api/search/map-adapter';

import { HotelResultsViewModel } from 'models';

import { FullPropertySearch, OperationResult } from '__generated__/api';

export const adaptFullPropertySearch: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel, // Undefined, but argument is present to adhere to interface.
  bexApiResults: OperationResult<FullPropertySearch.Query>
): HotelResultsViewModel => {
  const { data, extensions } = bexApiResults;

  const { propertySearch } = data;

  if (!propertySearch) {
    return bffResults;
  }

  const { summary } = propertySearch;

  const loyaltyInfo = summary && summary.loyaltyInfo;

  return {
    ...bffResults,
    defaultRequestFields: getDefaultRequestFields(
      data.propertySearch.searchCriteria,
      data.propertySearch.shoppingContext &&
        data.propertySearch.shoppingContext.multiItem &&
        data.propertySearch.shoppingContext.multiItem.id
    ),
    exitIntent: propertySearch && propertySearch.exitIntent,
    hotels: mapPropertySearchResults(data),
    loyaltyEducation: mapLoyaltyEducation(summary),
    loyaltyMessagingModel: loyaltyInfo && {
      loyaltyPointsMessage: loyaltyInfo.saveWithPointsMessage,
      swpActionMessage: loyaltyInfo.saveWithPointsActionMessage
    },
    map: mapMap(data),
    messages: mapMessages(summary),
    multiItemSearchContext: data.propertySearch.multiItemSearchContext,
    omnitureData: mapOmnitureData(extensions.analytics),
    resultSectionHeadings: summary && summary.resultSectionHeadings,
    searchAndFilterDisplayOptions: createSearchAndFilterDisplayOptions(),
    searchedDestination: mapSearchedDestination(data),
    sortAndFilter: mapSortAndFilter(data.propertySearch),
    intentMedia: propertySearch.intentMedia,
    summaryMessages: summary && summary.resultsSummary,
    totalPropertyCount: summary && summary.matchedPropertiesSize
  };
};
